import { ElementRef, Injectable } from '@angular/core';
import { Idle, DEFAULT_INTERRUPTSOURCES, EventTargetInterruptSource } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { AuthService } from './auth.service'; // Your existing AuthService
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  idleState = 'Not started.';
  idleCountDown: any;
  showDialog: boolean =false;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private authService: AuthService,
    private router: Router
  ) {  
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // Set default interrupt sources
  }

  // Set the idle timeout based on the token expiration time
  setIdleTimeout(expiresIn: number) {
    const idleTime = expiresIn - 120; // Start idle tracking 2 minute before token expiration
    const timeout = 60; // Give the user 1 minute to interact before timing out

    this.idle.setIdle(idleTime); // Set idle time based on token expiration
    this.idle.setTimeout(timeout); // Set the timeout (time after idle)
    this.keepalive.start();
    this.keepalive.interval(expiresIn-50);
    this.keepalive.onPing.subscribe(() => {
      this.refreshToken();
    });
    this.idle.onTimeout.subscribe(() => {
      this.idleState = 'Session expired.';
      this.showDialog = false;
      this.clearSession(); // Log out the user
    });

    this.idle.onIdleEnd.subscribe(() => {
      this.idleState = 'No longer idle.';
      this.showDialog = false;
    });

    this.idle.onIdleStart.subscribe(()=>{
      this.showDialog = true;
    });
    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleCountDown = countdown;
    });
    this.reset(); // Start watching for user activity
  }

  // Method to reset idle time tracking
  reset() {
    this.idle.watch();
    this.idleState = 'Started idle detection.';
  }

  // Log out the user
  public clearSession() {
    this.authService.logout();
    this.idle.stop();
    if(this.keepalive.isRunning())
      this.keepalive.stop();
  }

  refreshToken(){
    this.authService.refreshToken().subscribe({
      next: (res) => {
        this.authService.setToken(res.refresh_token);
        this.reset();
      },
      error:(e)=>{
        this.clearSession();
      }
    })
  }

}
